export enum VacancyStatus {
  Active = "Active",
  Closed = "Closed",
  Expired = "Expired",
}

export const VacancyStatusParser = (status: string): VacancyStatus => {
  switch (status) {
    case "Active":
      return VacancyStatus.Active;
    case "Closed":
      return VacancyStatus.Closed;
    case "Expired":
      return VacancyStatus.Expired;
    default:
      throw new Error(`Unknown vacancy status: ${status}`);
  }
};
